(function () {
  'use strict';
  if (customElements.get('halo-kit-carousel')) return;
  class HaloKitCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.halo-kit-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-kit-index]'));
      this.index = 0;
      this.visible = false;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.click = (event) => {
        const dot = event.target.closest('[data-kit-index]');
        if (dot) {
          this.show(Number(dot.dataset.kitIndex));
        }
        this.sync();
      };
      this.sync = () => {
        clearTimeout(this.timer);
        const stopped = !this.visible || document.hidden || this.reduce.matches || Boolean(this.drag);
        this.classList.toggle('is-paused', stopped);
        if (!stopped) this.timer = setTimeout(() => {
          this.show((this.index + 1) % this.slides.length);
          this.sync();
        }, 2240);
      };
      this.pointerDown = (event) => {
        const stage = event.target.closest('.halo-kit-carousel__stage');
        if (!stage || !event.isPrimary || event.button !== 0) return;
        this.drag = { x: event.clientX, y: event.clientY };
        stage.setPointerCapture(event.pointerId);
        clearTimeout(this.timer);
      };
      this.pointerUp = (event) => {
        if (!this.drag) return;
        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;
        this.drag = null;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
        this.sync();
      };
      this.pointerCancel = () => { this.drag = null; this.sync(); };
      this.keyDown = (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.sync();
      };
      this.addEventListener('click', this.click);
      this.addEventListener('pointerdown', this.pointerDown);
      this.addEventListener('pointerup', this.pointerUp);
      this.addEventListener('pointercancel', this.pointerCancel);
      this.addEventListener('keydown', this.keyDown);
      document.addEventListener('visibilitychange', this.sync);
      this.reduce.addEventListener('change', this.sync);
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.sync();
    }
    show(index) {
      index = (index + this.slides.length) % this.slides.length;
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
        this.dots[i].setAttribute('aria-pressed', String(i === index));
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.observer) this.observer.disconnect();
      this.removeEventListener('click', this.click);
      this.removeEventListener('pointerdown', this.pointerDown);
      this.removeEventListener('pointerup', this.pointerUp);
      this.removeEventListener('pointercancel', this.pointerCancel);
      this.removeEventListener('keydown', this.keyDown);
      document.removeEventListener('visibilitychange', this.sync);
      if (this.reduce) this.reduce.removeEventListener('change', this.sync);
    }
  }
  customElements.define('halo-kit-carousel', HaloKitCarousel);
})();
